import { render, staticRenderFns } from "./HelpSocial.vue?vue&type=template&id=9bbce93c"
import script from "./HelpSocial.vue?vue&type=script&lang=js"
export * from "./HelpSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports